export default __webpack_public_path__ + "static/media/card2.9e690eaa.svg";